import React, {useState, useRef, useEffect} from "react";
import PropTypes from "prop-types";

/**
 * Presentational dropdown that receives an array of filter definitions:
 * [{ key, label, type, enabled }]
 * and a toggle handler handleFilterSwitch(key).
 *
 * //todo redundant with FilterDropdown and FilterCalendar
 */
const FilterDropdown = ({label, filters, handleFilterSwitch}) => {
  const [open, setOpen] = useState(false);
  const dropRef = useRef(null);

  useEffect(() => {
    function onDocClick(e) {
      if (dropRef.current && !dropRef.current.contains(e.target)) setOpen(false);
    }

    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  return (
    <div className="component-filter-dropdown">
      <div className="filter-dropdown" ref={dropRef}>
        <button
          type="button"
          className="filter-dropdown__trigger"
          onClick={() => setOpen(v => !v)}
        >
          {label} <span className="arrow">{open ? "▲" : "▼"}</span>
        </button>

        {open && (
          <div className="filter-dropdown__menu">
            <ul>
              {filters.map(f => (
                <li
                  key={f.key}
                  className={`filter-item ${f.enabled ? "active" : ""}`}
                  onClick={() => handleFilterSwitch(f.key)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleFilterSwitch(f.key);
                  }}
                >
                  <input
                    type="checkbox"
                    readOnly
                    checked={!!f.enabled}
                    aria-label={f.label}
                  />
                  <span className="label">{f.label}</span>
                  {/*<small className="type">{f.type}</small>*/}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

FilterDropdown.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      type: PropTypes.string,
      enabled: PropTypes.bool,
    })
  ).isRequired,
  handleFilterSwitch: PropTypes.func.isRequired,
};

export default FilterDropdown;
